import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const alertPoliciesRoute: InvariantJiraRoute = {
	name: 'eoc-team-policies',
	path: '/jira/ops/teams/:teamId/policies',
	exact: true,
};
